import {Box} from "@mui/material";
import {orderStatus} from "../../../../../_constants";

export const OrderStatusTag = ({status}) => {
    const reverseSlug = (str) => {
        return str.replace(/_/g, ' ');
    }

    const renderStatus = (status) => {
        if( status === orderStatus.PLACED
            || status === orderStatus.REFUNDED
            || status === orderStatus.PARTIALLY_REFUNDED
        ){
            return styles.refunded
        } else if(status === orderStatus.CANCELLED){
            return styles.cancelled
        } else{
            return styles.fulfilled
        }
    }

    return(
        <Box sx={{...styles.main, ...renderStatus(status)}}>
            {reverseSlug(status.toLowerCase())}
        </Box>
    )
}

const styles = {
    main: {
        minWidth: "fit-content",
        borderRadius: "999px",
        padding: "5px 10px",
        fontFamily: "FustatSemiBold",
        fontSize: "12px",
        lineHeight: "100%",
        margin: "0px",
        textTransform: "capitalize",
    },
    fulfilled: {
        backgroundColor: "#dcfce6",
        color: "#69be7b",
    },
    cancelled: {
        backgroundColor: "#fed1d7",
        color: "#c70a24",
    },
    refunded: {
        backgroundColor: "#fadcb6",
        color: "#e5a500",
    }
}